module.exports = __webpack_public_path__ + "img/tent001.a6a4b6c4.jpg";